import { useTranslations } from '@vocab/react';
import { Box, Stack, Text } from 'braid-design-system';

import translations from '../.vocab';

import upsellImage from './premium-upsell-v2.png';

import * as styles from '../index.css';

export const UpsellImagePanel = () => {
  const { t } = useTranslations(translations);

  return (
    <Box
      textAlign={['center']}
      padding="small"
      background="formAccentSoft"
      borderRadius="large"
      height="full"
      className={styles.image}
      marginBottom={['xsmall', 'none']}
    >
      <Stack space="xxsmall" align="center">
        <img
          src={upsellImage}
          alt={t('premium-upsell-image-description')}
          width="100%"
          height="100%"
        />
        <Text size="xsmall" tone="secondary">
          {t('premium-upsell-image-description')}
        </Text>
      </Stack>
    </Box>
  );
};
